export default {
  'account.password.title': 'Change Password',
  'account.password.subtitle': 'Update your login password',
  'account.password.loggedInAs': 'Signed in as {username}',
  'account.password.current': 'Current password',
  'account.password.currentPlaceholder': 'Enter your current password',
  'account.password.currentRequired': 'Please enter your current password',
  'account.password.new': 'New password',
  'account.password.newPlaceholder': 'Enter a new password',
  'account.password.newRequired': 'Please enter a new password',
  'account.password.confirm': 'Confirm new password',
  'account.password.confirmPlaceholder': 'Re-enter the new password',
  'account.password.confirmRequired': 'Please confirm the new password',
  'account.password.minLength': 'Password must be at least 6 characters',
  'account.password.mismatch': 'The two new passwords do not match',
  'account.password.submit': 'Save new password',
  'account.password.success': 'Password updated. Please sign in again with your new password.',
  'account.password.failed': 'Failed to change password. Please try again.',
  'account.password.notLoggedIn': 'Please sign in first',
};
